// Client Rate Estimator — standalone left-nav page.
//
// Resolves the logged-in user's client and renders the client Rate Browser.
// No client dropdown (a client only ever sees their own account); prices are
// returned marked-up (the /me rate-quote endpoint applies the client's carrier
// margins via the SAME compute_shipping_cost used at billing time), so the
// estimate matches what the client is charged when an order ships.

import { useQuery } from '@tanstack/react-query'
import { Calculator, Loader2 } from 'lucide-react'
import RateBrowserTab from './tabs/RateBrowserTab'
import { getMe } from '../../lib/api'

export default function ClientRateEstimator() {
  const { data: me, isLoading } = useQuery({
    queryKey: ['me'],
    queryFn: getMe,
    staleTime: 60_000,
  })
  const clientId = (me?.clients || [])[0]?.id

  return (
    <div className="space-y-5">
      <div className="flex items-center gap-2">
        <Calculator className="text-blue-600" />
        <h1 className="text-xl font-bold text-slate-800">Rate Estimator</h1>
      </div>

      {isLoading ? (
        <div className="flex justify-center py-12"><Loader2 className="animate-spin text-slate-400" /></div>
      ) : clientId ? (
        <RateBrowserTab clientId={clientId} />
      ) : (
        <div className="card p-8 text-center text-sm text-slate-500">
          No account is linked to your login yet.
        </div>
      )}
    </div>
  )
}
